/* DEBUT animation de zoom */
window.addEventListener('scroll', () => {
    const zoomInElem = document.querySelector(".custom-zoom-in-container");

    if (zoomInElem) {
        const zoomInRect = zoomInElem.getBoundingClientRect();
        const bodyRect = document.body.getBoundingClientRect();
        const zoomInOffset = zoomInRect.top - bodyRect.top;

        // console.log("pageYOffset = ", window.pageYOffset, ", body.offsetHeight = ", document.body.offsetHeight, ", window.innerHeight = ", window.innerHeight, ", zoomInOffset = ", zoomInOffset);
        document.body.style.setProperty('--scroll', (window.pageYOffset + 300 - zoomInOffset) / (document.body.offsetHeight - window.innerHeight));
    } else {
        document.body.style.setProperty('--scroll', window.pageYOffset / (document.body.offsetHeight - window.innerHeight));
    }
}, false);
/* FIN animation de zoom */

const appHeight = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}
window.addEventListener('resize', appHeight);
appHeight();

/* DEBUT waitForElement */

function waitForElement(selector, callback) {
    const interval = setInterval(() => {
        const element = document.querySelector(selector);
        if (element) {
            clearInterval(interval);
            callback(element);
        }
    }, 100); // Check every 100ms
}

// Usage
// waitForElement('.widget_inner > h2', (h2Elem) => {

/* FIN waitForElement */



/* DEBUT custom section rendering */
/* Usage : mySectionRendering(sectionName = id de la section à afficher == nom du fichier dans le dossier section, targetDestination = selecteur de l'element où coller le code généré, pageReference = url de la page source d'informations) */
function mySectionRendering(sectionName, targetDestination, pageReference) {
    var url;
    if (sectionName) {
        if (pageReference) {
            url = pageReference + `/?section_id=` + sectionName;
        } else {
            url = document.location.href + `/?section_id=` + sectionName;    
        }

        fetch(url)
            .then(res => res.text())
            .then((responseJson) => {
                const destination = document.querySelector(targetDestination);

                if (destination) {
                    destination.innerHTML += responseJson;
                }
            });
    }
    return;
}
/* FIN custom section rendering */

function toggleShowClass(selector) {
    const element = document.querySelector(selector);

    if (element)
        element.classList.toggle("show");
}

function verifCheckboxChecked(checkboxSelector) {
    if (checkboxSelector) {
        const checkbox = document.querySelector(checkboxSelector);

        if (checkbox) {
            if (checkbox.checked != true) {
                checkbox.classList.add("red");
                return false;
            } else {
                checkbox.classList.remove("red");
            }
        }
    }
}

function sendPopupNL() {
    const popupForm = document.querySelector("#popup-nl .my-popup-nl-form");
    var myValue = "";

    if (verifCheckboxChecked("#checkbox-popup-nl") == false) {
        return false;
    }
    if (popupForm) {
        const birthdateInput = document.querySelector("#popup-nl-birthdate");
        const langInput = document.querySelector("#popup-nl-lang");
        const sourceInput = document.querySelector("#popup-nl-source");
        const countryInput = document.querySelector("#popup-nl-lang");
        const tagsInput = document.querySelector("#popup-nl-tags");
        const day = document.querySelector("#day");
        const month = document.querySelector("#month");
        const year = document.querySelector("#year");

        if (birthdateInput && day && month && year) {
            birthdateInput.value = day.value+"/"+month.value+"/"+year.value;
            myValue += "birthdate: "+myValue+day.value+"/"+month.value+"/"+year.value+", ";
        }
        if (langInput && sourceInput) {
            var lang = document.documentElement.lang;

            if (lang == "fr") {
                sourceInput.value = "shopify_fr";
                myValue += "source: shopify_fr, ";
            } else {
                sourceInput.value = "shopify_en";
                myValue += "source: shopify_fr, ";
            }
            langInput.value = lang;
            myValue += "lang: "+lang+", ";
        }
        if (countryInput) {
            myValue += "country: "+countryInput.value+", "
        }
        if (tagsInput) {
            tagsInput.value = myValue+"newsletter";
        }
        popupForm.submit();
    }
}

function openNLPopup(emailSelector, checkboxSelector) {
    const popupNL = document.getElementById('popup-nl');
    const emailInput = document.querySelector(emailSelector);

    if (!emailInput.value.includes("@")) {
        emailInput.parentNode.style.border = "1px solid red";
        return false;
    }
    if (verifCheckboxChecked(checkboxSelector) == false) {
        return false;
    }
    document.body.classList.add("no-scroll");
    if (popupNL) {
        popupNL.classList.add("show");

        if (emailSelector) {
            const element = document.querySelector(emailSelector);

            if (element) {
                const email = element.value;
                const target = document.querySelector('#input-email-popup-nl');

                if (target && email) {
                    target.value = email;
                }
            }
        }
    } else {
        if (document.documentElement.lang === "en") {
            mySectionRendering("popup-nl", "body", "https://minuty.com/en/");
        } else {
            mySectionRendering("popup-nl", "body", "https://minuty.com/");
        }
        if (emailSelector) {
            const element = document.querySelector(emailSelector);

            if (element) {
                const email = element.value;
    
                waitForElement('#input-email-popup-nl', (elem) => {
                    elem.value = email;
                });
            }
        }
    }
}

function displayEnveloppe() {
    const cookie = getCookie("enveloppe");
    const container = document.getElementById("enveloppe-container-parent");

    if (!cookie) {
        if (container) {
            var expires = 0;
            var date = new Date();
            var days = 30;
            date.setDate(date.getDate()+days);
            expires = "; expires="+date.toUTCString();
            document.cookie = "enveloppe=true"+expires+"; path=/";
            container.classList.add("show");
        }
    }
}

/* AGEGATE */
function getCookie(c_name) {
    var c_value = document.cookie,
        c_start = c_value.indexOf(" " + c_name + "=");
    if (c_start == -1) c_start = c_value.indexOf(c_name + "=");
    if (c_start == -1) {
        c_value = null;
    } else {
        c_start = c_value.indexOf("=", c_start) + 1;
        var c_end = c_value.indexOf(";", c_start);
        if (c_end == -1) {
            c_end = c_value.length;
        }
        c_value = unescape(c_value.substring(c_start, c_end));
    }
    return c_value;
}
  
window.addEventListener('load', function() {
    const agegate = document.getElementById("agegate");
    const cookie = getCookie("agegate");
  
    if (agegate && !cookie) {
      agegate.classList.add("show");
      document.body.classList.add("no-scroll");
    }
    setTimeout(displayEnveloppe, 5000);
    if (cookie) {
      if (cookie === "FR") {
        this.document.body.classList.add("country-france");
      } else if (cookie !== "FR") {
        this.document.body.classList.add("country-hors-france");
      }
    }
});
  
/* FIN AGEGATE */

/* DEBUT EXTERNAL LINKS / LIENS EXTERNES */
// anonymous function to self contain variables
$(document).ready(function() { 
    $('a').attr('rel', function() {
      if(this.host != location.host) return 'nofollow noopener noreferrer';
    });
});
/* FIN EXTERNAL LINKS / LIENS EXTERNES */